// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: any;

export const initializePendo = (user: { id: string; email: string; full_name: string }) => {
    if (window.pendo && user) {
        const options = {
            visitor: {
                id: user.id,
                email: user.email,
                full_name: user.full_name,
            },
        };

        if (window.pendo.visitorId) {
            window.pendo.identify(options);
        } else {
            window.pendo.initialize(options);
        }
    }
};
